import BaseSportScoring from './BaseSportScoring';

class BasketballScoring extends BaseSportScoring {
  constructor() {
    super('basketball');
  }

  get label() { return 'Basketball'; }
}

export default BasketballScoring;
